import { render, staticRenderFns } from "./JobworkerView.vue?vue&type=template&id=d4d6a206&scoped=true"
import script from "./JobworkerView.vue?vue&type=script&lang=js"
export * from "./JobworkerView.vue?vue&type=script&lang=js"
import style0 from "./JobworkerView.vue?vue&type=style&index=0&id=d4d6a206&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4d6a206",
  null
  
)

export default component.exports